import Analytics from '@/utils/analytics';
import moment from 'moment-timezone';
import { getDeviceTimezone } from '@/utils/date';

// Always GMT with English names, so parsed with the en locale regardless of the app locale
const HTTP_DATE_FORMAT = 'ddd, DD MMM YYYY HH:mm:ss [GMT]';
const HTTP_DATE_RESOLUTION_MS = 1000;
const MAX_SAMPLE_ROUND_TRIP_MS = 5000;
const CLOCK_SKEW_THRESHOLD_MS = 5000;
const OFFSET_UPDATE_THRESHOLD_MS = 5000;
const CLOCK_SKEW_TRACKING_THRESHOLD_MS = 2 * 60 * 1000;

let offsetMs = 0;
let hasTrackedClockSkew = false;

export const getTrueTime = (): number => Date.now() + offsetMs;

export const updateTrueTime = (
  dateHeader: string,
  sentAt: number,
  receivedAt: number,
) => {
  const roundTripMs = receivedAt - sentAt;
  if (roundTripMs > MAX_SAMPLE_ROUND_TRIP_MS) {
    return;
  }

  const serverDate = moment.utc(dateHeader, HTTP_DATE_FORMAT, 'en', true);
  if (!serverDate.isValid()) {
    return;
  }

  const sampleOffsetMs =
    serverDate.valueOf() +
    HTTP_DATE_RESOLUTION_MS / 2 -
    (sentAt + receivedAt) / 2;

  const nextOffsetMs =
    Math.abs(sampleOffsetMs) > CLOCK_SKEW_THRESHOLD_MS ? sampleOffsetMs : 0;
  const isWithinUpdateThreshold =
    Math.abs(nextOffsetMs - offsetMs) <= OFFSET_UPDATE_THRESHOLD_MS;
  if (
    nextOffsetMs === offsetMs ||
    (nextOffsetMs !== 0 && offsetMs !== 0 && isWithinUpdateThreshold)
  ) {
    return;
  }

  offsetMs = nextOffsetMs;

  if (
    !hasTrackedClockSkew &&
    Math.abs(offsetMs) > CLOCK_SKEW_TRACKING_THRESHOLD_MS
  ) {
    hasTrackedClockSkew = true;
    Analytics.track('user.device_clock_skewed', {
      deviceTime: new Date(receivedAt).toISOString(),
      deviceTimezone: getDeviceTimezone(),
      offsetSeconds: Math.round(offsetMs / 1000),
      roundTripMs,
      trueTime: new Date(receivedAt + offsetMs).toISOString(),
    });
  }
};
